// extracted by mini-css-extract-plugin
export var cardHeader = "_ez-1";
export var contentCard = "_ez-0";
export var headerActions = "_ez-3";
export var reorderHandle = "_ez-5";
export var titleArea = "_ez-2";
export var titleAreaWithHandle = "_ez-4";